import script from "./UploadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadButton.vue?vue&type=script&setup=true&lang=ts"

import "./UploadButton.vue?vue&type=style&index=0&id=c262f972&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c262f972"]])

export default __exports__